import { type IconName, LandingIcon } from "./LandingIcon";

const FEATURES: readonly { icon: IconName; title: string; body: string }[] = [
  {
    icon: "trending-up",
    title: "Costo acumulado por animal",
    body: "Registrá cada peso invertido en crianza, alimentación y sanidad. HATO acumula el costo por animal hasta el primer parto, donde se capitaliza como activo biológico.",
  },
  {
    icon: "clock",
    title: "Depreciación automática del hato",
    body: "El sistema deprecia tu inventario productivo cada mes según vida útil y valor residual que vos configurás. Coherente con NIIF PYMES Sección 34.",
  },
  {
    icon: "file-check",
    title: "Export contable inmutable",
    body: "Generá los asientos del período en Excel sellado y firmado con hash criptográfico. El contador lo recibe listo para su sistema; las correcciones se emiten como ajuste en el siguiente período.",
  },
  {
    icon: "users",
    title: "Roles diferenciados",
    body: "El capataz registra eventos del hato sin ver montos contables. El contador ve todo en modo lectura. Vos y el contador trabajan sobre la misma data, sin pisarse.",
  },
];

export function LandingFeatures() {
  return (
    <section id="features" className="relative z-10 border-white/[0.06] border-b bg-brand-dark">
      <div className="border-white/[0.06] border-b px-6 py-16 md:px-12">
        <h2 className="js-mask-reveal font-medium text-2xl text-white tracking-tight md:text-3xl">
          Diseñado para tu contador. Usable por tu finca.
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2">
        {FEATURES.map((it, i) => (
          <div
            key={it.title}
            className={`scroll-fade group p-8 md:p-16 ${
              i % 2 === 0 ? "md:border-white/[0.06] md:border-r" : ""
            } ${i < 2 ? "border-white/[0.06] border-b" : ""}`}
          >
            <div className="mb-8 flex h-12 w-12 items-center justify-center rounded-xl border border-white/[0.08] bg-white/[0.02] text-white shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)] transition-colors group-hover:border-primary-500/30">
              <LandingIcon name={it.icon} size={24} />
            </div>
            <h3 className="mb-3 font-medium text-lg text-white tracking-tight">{it.title}</h3>
            <p className="text-neutral-400 text-sm leading-relaxed">{it.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
